import { useState, useRef, useEffect } from 'react'

/** 交叉观察器 */
export const useIntersectionObserver = <T extends HTMLElement>(
  options?: IntersectionObserverInit
) => {
  const ref = useRef<T>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      // 交叉时，则停止观察
      if (entry.isIntersecting) {
        setIsVisible(true)
        ref.current && observer.unobserve(ref.current)
      }
    }, options)

    if (ref.current) {
      // 开始观察
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  return { ref, isVisible }
}
